import { useEffect, useState } from "react";
import useGetUserInfo from "features/users/hooks/useGetUserInfo";
import RepositoryFactory from "domain/adapter/RepositoryFactory";
import isDomainError from "ui/adapter/utils/isDomainError";
import { i18nextInitializationPromise } from "ui/locale/i18n";
import ServiceFactory from "domain/adapter/ServiceFactory";
import { initApi } from "features/shared/api/initApi";
import { authService } from "features/auth/services/authService";
import { useAuthStore } from "features/auth/store/authStore";

export function useLoad(): boolean {
    const { refetch: prefetchUserInfo } = useGetUserInfo({ enabled: false });
    const [loading, setLoading] = useState(true);

    const initFactories = async () => {
        try {
            await RepositoryFactory.init();
            await ServiceFactory.init();
            await authService.loadAuthToken();

            initApi({
                getToken: () => authService.getAccessToken(),
                onLogout: () => authService.logout(),
                onRefreshToken: async () => {
                    try {
                        await authService.getAccessToken();
                        return true;
                    } catch {
                        return false;
                    }
                },
            });
        } catch (e) {
            if (!isDomainError(e) || e.code !== "SESSION_EXPIRED") throw e;
        }
    };

    useEffect(() => {
        // skipcq: JS-0328
        (async function () {
            const factoriesInitPromise = initFactories();

            await Promise.all([factoriesInitPromise, i18nextInitializationPromise /* + other init promises */]);

            if (useAuthStore.getState().isLoggedIn) await prefetchUserInfo();
            setLoading(false);
        })();
    }, []);

    return loading;
}
